import { useLanguage } from "@/i18n/LanguageContext";

const brands = [
  { name: "GARRETT", color: "#0072CE" },
  { name: "BorgWarner", color: "#F26522" },
  { name: "KKK", color: "#E2001A" },
  { name: "MITSUBISHI", color: "#E60012" },
  { name: "IHI", color: "#003DA5" },
  { name: "HOLSET", color: "#C8102E" },
  { name: "Continental", color: "#FF9E1B" },
  { name: "HITACHI", color: "#E60027" },
  { name: "SCHWITZER", color: "#0093D0" },
  { name: "MELETT", color: "#E30613" },
  { name: "JRONE", color: "#00A0DF" },
  { name: "E&E Turbos", color: "#00A651" },
];

export const Brands = () => {
  const { t } = useLanguage();
  const loop = [...brands, ...brands];

  return (
    <section id="brands" data-testid="brands-section" className="py-16 sm:py-20 lg:py-24 carbon border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-10">
          <p className="text-sm font-bold uppercase tracking-[0.25em] text-red-500 mb-4">{t.brands.eyebrow}</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold uppercase tracking-tight leading-tight text-white">
            {t.brands.heading}
          </h2>
        </div>
      </div>

      <div className="relative overflow-hidden">
        {/* edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-32 z-10 bg-gradient-to-r from-[#0a0a0b] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-32 z-10 bg-gradient-to-l from-[#0a0a0b] to-transparent" />

        <div className="marquee-track">
          {loop.map((brand, i) => (
            <div
              key={i}
              data-testid={`brand-logo-${i}`}
              className="group flex items-center justify-center shrink-0 px-8 sm:px-14"
            >
              <span
                style={{ color: brand.color }}
                className="font-display font-bold text-2xl sm:text-4xl uppercase tracking-tight transition-transform duration-300 group-hover:scale-110 whitespace-nowrap"
              >
                {brand.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
